import { render, staticRenderFns } from "./AuthorPage.vue?vue&type=template&id=47e8b7c2&"
import script from "./AuthorPage.vue?vue&type=script&lang=ts&"
export * from "./AuthorPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports